import { shallowEqual, useSelector } from 'react-redux';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

// The URL of the site logo, relative to the app. During server rendering the
// @site endpoint gives a URL on the internal API host, which browsers cannot
// reach. The frontend serves the logo at the same path.
export function useSiteLogo(): string {
  const logo = useSelector(
    (state: any) => state.site?.data?.['plone.site_logo'],
    shallowEqual,
  );
  return logo ? flattenToAppURL(logo) : '';
}
